import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import FreeTextAnswer from './freeTextAnswer';
import VerticalAnswer from './verticalAnswer';
import HorizontalAnswers from './horizontalAnswers';
import EnpsFreeTextAnswer from './enpsFreeTextAnswer';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

const Answers = ({
  translations,
  answers,
  isSingleReview = false,
  withTextReplyQuestions = false,
  isEnpsOpenEndedQuestion = false,
  subjects = [],
  results = {},
  isVertical,
  questionId = 0,
  hasNeutralAnswer = false,
  answerReplyErrors = {},
  isPreview = false,
  isInsightsView = false,
  isAttributePreview = false,
  hasAddCommentButton = false,
  onSetAnswerReplyErrors = () => {},
  onSelect = () => {},
  onChange = () => {},
  onAddComment = () => {},
}) => {
  const classes = useStyles();

  if (isEnpsOpenEndedQuestion) {
    return (
      <div className={classes.root}>
        {subjects.map(subject => {
          return (
            <EnpsFreeTextAnswer
              key={`answer_item_${subject.id}`}
              translations={translations}
              initialAnswer={results?.[subject.review_tracking]?.[questionId]}
              questionId={questionId}
              subject={subject}
              error={answerReplyErrors?.[subject.review_tracking]}
              isDisabled={isPreview}
              isInsightsView={isInsightsView}
              onSetError={onSetAnswerReplyErrors}
              onChange={onChange}
            />
          );
        })}
      </div>
    );
  }

  if (withTextReplyQuestions) {
    return (
      <div className={classes.root}>
        {subjects.map(subject => {
          return (
            <FreeTextAnswer
              key={`answer_item_${subject.id}`}
              translations={translations}
              initialAnswer={results?.[subject.review_tracking]?.[questionId]}
              questionId={questionId}
              subject={subject}
              error={answerReplyErrors?.[subject.review_tracking]}
              isSingleReview={isSingleReview}
              hasNeutralAnswer={hasNeutralAnswer}
              isDisabled={isPreview}
              isInsightsView={isInsightsView}
              onSetError={onSetAnswerReplyErrors}
              onChange={onChange}
            />
          );
        })}
      </div>
    );
  }

  if (isVertical) {
    return (
      <div className={classes.root}>
        {answers.map((answer, index) => (
          <VerticalAnswer
            key={`answer_item_${answer.id ?? answer.order ?? index}`}
            questionId={questionId}
            subjects={subjects}
            answer={answer}
            selection={results}
            neutralAnswerLabel={translations.neutralAnswer.label}
            isSingleReview={isSingleReview}
            isDisabled={isPreview}
            isAttributePreview={isAttributePreview}
            isInsightsView={isInsightsView}
            hasAddCommentButton={hasAddCommentButton}
            onSelect={onSelect}
            onAddComment={onAddComment}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <HorizontalAnswers
        questionId={questionId}
        neutralAnswerLabel={translations.neutralAnswer.label}
        weightLabel={translations.weight}
        answers={answers}
        selection={results}
        subjects={subjects}
        isDisabled={isPreview}
        isSingleReview={isSingleReview}
        isInsightsView={isInsightsView}
        isAttributePreview={isAttributePreview}
        hasAddCommentButton={hasAddCommentButton}
        onSelect={onSelect}
        onAddComment={onAddComment}
      />
    </div>
  );
};

Answers.propTypes = {
  translations: PropTypes.shape({}).isRequired,
  isVertical: PropTypes.bool.isRequired,
  isSingleReview: PropTypes.bool,
  withTextReplyQuestions: PropTypes.bool,
  isEnpsOpenEndedQuestion: PropTypes.bool,
  isPreview: PropTypes.bool,
  isInsightsView: PropTypes.bool,
  isAttributePreview: PropTypes.bool,
  hasNeutralAnswer: PropTypes.bool,
  answers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  subjects: PropTypes.arrayOf(PropTypes.shape({})),
  results: PropTypes.shape({}),
  questionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  answerReplyErrors: PropTypes.shape({}),
  onSetAnswerReplyErrors: PropTypes.func,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  onAddComment: PropTypes.func,
  hasAddCommentButton: PropTypes.bool,
};

export default Answers;
